export default __webpack_public_path__ + "static/computer-d2f2e2400e693062c619580ff62bbf59.png";